import { useState } from 'react';
import SubTabs from '../components/SubTabs.jsx';
import ImportMonthMatrix from '../components/import/ImportMonthMatrix.jsx';

// Every source uses the same month matrix. There is no separate Import History tab: a
// batch's month is the context that matters, and the matrix row already is that month, so
// history as a second list only showed the same batch twice in two different shapes.
const SUB_TABS = [
  { id: 'statex',      label: 'Statex' },
  { id: 'paid_media',  label: 'Paid Media' },
  { id: 'offline',     label: 'Offline' },
  { id: 'direct_buys', label: 'Direct Buys' },
];

export default function ImportDataPage() {
  const [subTab, setSubTab] = useState('statex');

  return (
    <div style={{ padding: 20 }}>
      <h4>Import Data</h4>
      <p className="muted" style={{ marginBottom: 16 }}>
        Upload Statex, Paid Media, Offline, and Direct Buys files. Imports are scoped to the
        selected client, checked for duplicates against the same period, and mapped against
        the client's saved column mapping before committing.
      </p>

      <SubTabs tabs={SUB_TABS} active={subTab} onChange={setSubTab} />

      <ImportMonthMatrix sourceType={subTab} />
    </div>
  );
}
